import { useState, useEffect, useRef } from 'react'

import Article from '../components/Article.js'
import Experience from '../components/Experience.js'
import Fader from '../components/Fader.js'
import FixedPosition from '../components/FixedPosition.js'
import HomeContent from '../components/HomeContent.js'
import Menu from '../components/Menu.js'
import ScrollButton from '../components/ScrollButton.js'
// import Summary from '../components/Summary.js'
import Video from '../components/Video.js'
import WelcomeUIAnimation from '../components/WelcomeUIAnimation'

import articles from '../content/articles.js'

export default function Home()
{
    const outerDivRef = useRef(null)

    // ANIMATION
    const [animationStage, setAnimationStage] = useState(0)

    // ARTICLE
    const [currentArticleIndex, setCurrentArticle] = useState(0)
    const [articleOpen, setArticleOpen] = useState(false)

    // SCROLL
    const [scrolledDown, setScrolledDown] = useState(false)

    const scrolledDownChange = () =>
    {
        const hasScrolled = window.scrollY >= (window.innerHeight * 0.7)

        if (hasScrolled !== scrolledDown)
        {
            setScrolledDown(hasScrolled)
        }
    }
    window.addEventListener('scroll', scrolledDownChange)

    useEffect(() =>
    {
        // ANIMATION
        setTimeout(() => { setAnimationStage(1) }, 3000)  // OUT: The Death of the Cyrus Cylinder
        setTimeout(() => { setAnimationStage(2) }, 6000) // OUT: You're about to see the first ever Decleration of Human Rights.
        setTimeout(() => { setAnimationStage(3) }, 10000) // OUT: Written in Iran, bring killed alongside its people. Find out Why.
        setTimeout(() => { setAnimationStage(4) }, 10500) // OUT: to nav
        setTimeout(() => { setAnimationStage(5) }, 15000) // OUT: out entirely

        // SCROLL
        // return () => window.removeEventListener('scroll', scrolledDownChange)
    }, [])

    return (
        <div style={{ width: '100%' }} ref={outerDivRef}>

            {/* <FixedPosition fixed zIndex={0}>
                <Video scrolledDown={scrolledDown} />
            </FixedPosition> */}

            <Experience
                animateInDelay={12}

                shardsCount={articles.length}
                setArticleOpen={setArticleOpen}
                setCurrentArticleIndex={setCurrentArticle}
            />
            <Fader animationStage={animationStage} />
            <FixedPosition >
                <WelcomeUIAnimation animationStage={animationStage} />
            </FixedPosition>

            <FixedPosition fixed zIndex={2}>
                <Menu visible={animationStage >= 4} />
            </FixedPosition>

            {articleOpen && <Article article={articles[currentArticleIndex]} setArticleOpen={setArticleOpen} />}

            <FixedPosition textAlignCenter>
                <ScrollButton visible={animationStage >= 4 && !scrolledDown} />
            </FixedPosition>

            <HomeContent />
        </div>
    )
}